
export default [
  {
    path: '/admin/loan-recoveries',
    name: 'loan-recovery',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/loan-recovery')
  }
]
